<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="form-field">
        <input-field
          id="checkedListboxSearch"
          v-model="search"
          placeholder="Escribe tu consulta..."
        >Buscar</input-field>
      </div>
    </div>
    <div class="col-xs-12">
      <p>
        <label :for="name + 't'">
          <input @change="seleccionarTodos" v-model="todos" type="checkbox" :id="name + 't'" />
          <span>Seleccionar todo</span>
        </label>
      </p>
    </div>
    <div v-if="!agrupar" class="col-xs-12">
      <div class="row">
        <div
          v-show="similiarToSearch(item[label])"
          :key="index"
          v-for="(item, index) in items"
          class="col-xs-12 col-md-6"
        >
          <label :for="name.toString() + index.toString()">
            <input
              v-model="modelValue[index]"
              :value="item[field]"
              type="checkbox"
              :name="name"
              :id="name.toString() + index.toString()"
            />
            <span>{{ item[label] }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="col-xs-12" v-else>
      <div v-for="(group, key) in groupedItems" :key="key" class="row">
        <div v-show="similiarToSearch(key)" class="col-xs-12">
          <h6>
            <strong v-if="title==''">{{ key }}</strong>
            <strong v-else>{{ title }}</strong>
          </h6>
        </div>
        <div
          v-show="similiarToSearch(item[label])"
          :key="index"
          v-for="(item, index) in group"
          class="col-xs-12 col-md-6"
        >
          <label :for="name.toString() + index.toString() + key.toString()">
            <input
              v-model="modelValue[index]"
              :value="item[field]"
              type="checkbox"
              :name="name"
              :id="name.toString() + index.toString() + key.toString()"
            />
            <span>{{ item[label]  }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Number,
      required: false,
      default: 2
    },
    title: {
      type: String,
      required: false,
      default: ""

    },
    name: {
      type: String,
      required: false,
      default: ""
    },
    items: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    },
    value: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    label: {
      type: String,
      required: false,
      default: "descripcion"
    },
    field: {
      type: String,
      required: false,
      default: "id"
    },
    groupedBy: {
      type: String,
      required: false,
      default: ""
    }
  },
  data: function() {
    return {
      search: "",
      modelValue: this.value,
      todos: false,
      groupedItems: _.groupBy(this.items, this.groupedBy)
    };
  },
  methods: {
    similiarToSearch: function(value) {
      if (this.search === "") return true;
      else return value.toUpperCase().indexOf(this.search.toUpperCase()) != -1;
    },
    seleccionarTodos: function() {
      this.modelValue = [];
      if (this.todos)
        for (let i = 0; i < this.items.length; i++)
          this.modelValue.push(this.items[i][this.field]);
    }
  },
  computed: {
    agrupar: function() {
      return this.groupedBy != null && this.groupedBy !== "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/CheckedListbox.vue